import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';
import { environment } from './environments/environment';

document.title = environment.branding.clientName;
const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (favicon) {
  favicon.href = environment.branding.faviconUrl;
}

platformBrowser().bootstrapModule(AppModule, {
  
})
  .catch(err => console.error(err));
